import { styled } from "@mui/material/styles";
import { Avatar } from "@mui/material";

const MessagesMain = styled("div")(({ theme }) => ({
  width: "70%",
  display: "flex",
  flexDirection: "column",
  height: "90vh",
  "& span.no_message_text": {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "19px",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "5px",
  },
}));
const MessageHeaderMain = styled("div")(({ theme }) => ({
  height: "55px",
  backgroundColor: "#E1E1E1",
  borderBottom: "1px solid #616161",
  display: "flex",
  alignItems: "center",
  padding: "10px 10px",

  "& span": {
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
    paddingLeft: "10px",
  },
}));
const UserAvatar = styled(Avatar)(({ theme }) => ({
  width: "40px",
  height: "40px",
  backgroundColor: "#0B0B0B",
  fontFamily: theme.typography.fontFamily,
}));

const MessageContentMain = styled("div")(({ theme }) => ({
  flexGrow: 1,
  background: "#E1E1E1",
  height: "66%",
}));
const MessageContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginBottom: "10px",
  overflowX: "hidden",
  padding: "20px",

  "&.admin_messageContainer": {
    "& .sender_message_main , & .reciver_message_main": {
      maxWidth: "40%",
      "& .SingleImageWrapper": {
        width: "300px",
      },
      "& .sender_message_text": {
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "14px",
        lineHeight: "19px",
        color: "#0B0B0B",
        background: "#FFFFFF",
        borderRadius: "0px 0px 4px 4px",
        padding: "10px",
        borderRadius: "8px",
        "&::before": {
          content: "''",
          position: "absolute",
          top: "0",
          right: "-14px",
          width: "20px",
          height: "20px",
          background:
            "linear-gradient(135deg, #fff 0%, #fff 50%, transparent 50%, transparent)",
        },
      },
      "& .text_have_attachments": {
        "&::before": {
          content: "'none'",
          display: "none",
        },
      },
    },
    "& .reciver_message_main": {
      "& p": {
        background: "#454545",
        borderRadius: "0px 4px 4px 4px",
        color: "#FFFFFF",
        "&::before": {
          content: "''",
          position: "absolute",
          top: "0",
          left: "-12px",
          width: "20px",
          height: "20px",
          background:
            "linear-gradient(225deg, #454545 0%, #454545 50%, transparent 50%, transparent)",
        },
      },
    },
  },
}));

// =========== message section =============================
const MessageMain = styled("div")(({ theme }) => ({
  "&.ImageWrap": {
    width: "40%",
    "&::before": {
      content: "none",
    },
  },
  alignSelf: "flex-start",
  maxWidth: "75%",
  position: "relative",
  wordWrap: "break-word",
  "&.sender_TextWrap": {
    alignSelf: "flex-end",
    position: "relative",
    maxWidth: "75%",
    wordWrap: "break-word",
    marginLeft: "auto",
    "&::before": {
      content: "none",
    },
  },
  "&.sender_ImageWrap": {
    maxWidth: "75%",
    width: "40%",
    marginLeft: "auto",
    "&::before": {
      content: "none",
    },
  },
  "& #ReactSimpleImageViewer": {
    zIndex: "9999",
  },
  "& .react-simple-image-viewer__close": {
    fontSize: "33px ",
    fontWeight: 500,
  },
  "& .react-simple-image-viewer__next": {
    fontSize: "33px ",
    fontWeight: 500,
  },
  "& .react-simple-image-viewer__previous": {
    fontSize: "33px ",
    fontWeight: 500,
  },
}));

// const MessageText = styled("p")(({ theme }) => ({
//   fontStyle: "normal",
//   fontWeight: 400,
//   fontSize: "14px",
//   lineHeight: "19px",
//   color: "#0B0B0B",
//   background: "#FFFFFF",
//   borderRadius: "0px 0px 4px 4px",
//   padding: "10px",
//   borderRadius: "8px",
//   "&::before": {
//     content: "''",
//     position: "absolute",
//     top: "0",
//     right: "-14px",
//     width: "20px",
//     height: "20px",
//     background:
//       "linear-gradient(135deg, #fff 0%, #fff 50%, transparent 50%, transparent)",
//   },
//   "&.reciver_MessageText": {
//     background: "#454545",
//     borderRadius: "0px 4px 4px 4px",
//     color: "#FFFFFF",
//     "&::before": {
//       content: "''",
//       position: "absolute",
//       top: "0",
//       left: "-12px",
//       width: "20px",
//       height: "20px",
//       background:
//         "linear-gradient(225deg, #454545 0%, #454545 50%, transparent 50%, transparent)",
//     },
//   },
// }));

const MessageAction = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "end",
  gap: "10px",
  margin: "5px 0",
  "& svg": {
    fontSize: "16px",
  },
  "& span": {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "18px",
    color: "rgba(11, 11, 11, 0.6)",
    fontFamily: theme.typography.fontFamily,
  },
  "&.Reciver_MessageAction": {
    justifyContent: "start",
  },
}));

// =========== End message section =============================

export {
  MessagesMain,
  MessageHeaderMain,
  UserAvatar,
  MessageContentMain,
  MessageContainer,
  MessageMain,
  // MessageText,
  MessageAction,
};
